import React, { Component } from 'react';
import moment from 'moment';
import ChartHelper from '../Helper/ChartHelper';

export default class MetricsContestItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            expanded: false,
            userStanceObj: {}
        }

        this.chartHelper = new ChartHelper();


        this.toggleExpanded = this.toggleExpanded.bind(this);

        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToPlacement = this.convertToPlacement.bind(this);
        this.numberToShorthand = this.numberToShorthand.bind(this);

        this.generateMainIcon = this.generateMainIcon.bind(this);
        this.generateMainTitle = this.generateMainTitle.bind(this);
        this.generateMainNumbers = this.generateMainNumbers.bind(this);
        this.generateMainToggler = this.generateMainToggler.bind(this);
        this.generateRaffleMeat = this.generateRaffleMeat.bind(this);
        this.generateRankedMeat = this.generateRankedMeat.bind(this);
    }

    toggleExpanded() {
        this.props.expandContest(this.props.contest);
    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToPlacement(number) {

        if (number === null || number === undefined) {
            return null;
        }

        let mod10 = number % 10;
        let mod100 = number % 100;

        if (mod10 === 1 && mod100 != 11) {
            return number + "st";
        }
        if (mod10 === 2 && mod100 != 12) {
            return number + "nd";
        }
        if (mod10 === 3 && mod100 != 13) {
            return number + "rd";
        }

        return number + "th";
    }

    numberToShorthand(number) {
        if (number === null || number === undefined) {
            return null;
        }

        if (number >= 1000000) {
            return (number / 1000000.0).toFixed(1) + "M";
        } else if (number >= 1000) {
            return (number / 1000.0).toFixed(1) + "K";
        }

        return number + "";
    }

    generateMainIcon() {
        return (
            <div className="metrics-contest-item-icon-container">
                <div className="metrics-contest-item-icon">
                    <svg className="metrics-contest-item-icon-svg" style={{ fill: '#ffffff' }} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297">
                        <g>
                            <g>
                                <path d="M174.691,194.214c0-2.718-2.152-4.382-4.782-3.698c0,0-12.318,3.201-21.409,3.201s-21.409-3.201-21.409-3.201 c-2.63-0.684-4.782,0.98-4.782,3.698v14.329c0,2.718,2.224,4.941,4.941,4.941h42.5c2.718,0,4.941-2.224,4.941-4.941V194.214z" />
                            </g>
                            <g>
                                <path d="M223.615,9.884c0-5.458-4.426-9.884-9.884-9.884H83.269c-5.458,0-9.884,4.426-9.884,9.884v81.539 c0,25.522,7.591,48.754,21.374,65.415c13.874,16.771,32.96,26.008,53.741,26.008c20.781,0,39.867-9.236,53.741-26.008 c13.783-16.661,21.374-39.893,21.374-65.415V9.884z" />
                            </g>
                            <g>
                                <path d="M63.981,111.227c-13.525-5.033-19.753-16.706-19.753-36.111V30.969h18.285V11.202H34.346 c-5.459,0-9.884,4.425-9.884,9.884v54.029c0,32.961,15.788,53.039,44.818,57.729C66.895,125.985,65.109,118.749,63.981,111.227z" />
                            </g>
                            <g>
                                <path d="M83.269,228.31c-5.458,0-9.884,4.425-9.884,9.884v48.923c0,5.458,4.426,9.884,9.884,9.884h130.463 c5.458,0,9.884-4.426,9.884-9.884v-48.923c0-5.459-4.426-9.884-9.884-9.884H83.269z" />
                            </g>
                            <g>
                                <path d="M262.654,11.202h-28.168v19.767h18.285v44.146c0,19.405-6.228,31.078-19.753,36.111 c-1.128,7.522-2.913,14.759-5.299,21.618c29.03-4.69,44.818-24.768,44.818-57.729V21.086 C272.538,15.627,268.113,11.202,262.654,11.202z" />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        )
    }

    generateMainTitle() {
        return (
            <div className="metrics-contest-item-name-container">
                <div className="metrics-contest-item-name">
                    {this.props.contest.identity.name}
                </div>
            </div>
        );
    }

    generateMainNumbers() {
        let numberJsx = null;
        let numberIconJsx = null;

        if (this.props.contest.type === "raffle") {

            let topTicketCount = null;
            if (this.props.activeContestant === null || this.props.contest.data[this.props.activeContestant] === undefined) {
                topTicketCount = this.props.contest.totalTicketCount;
            } else {
                topTicketCount = this.props.contest.data[this.props.activeContestant];
            }

            numberJsx = (
                <div className="metrics-contest-item-number" style={{ width: 'calc(100% - 2rem)' }}>{this.numberToShorthand(topTicketCount)}</div>
            );
            numberIconJsx = (
                <div className="material-icons metrics-contest-item-number-icon">local_activity</div>
            );
        } else if (this.props.contest.type === "ranked") {
            let tmpPlace = null;
            for (var i = 0; i < this.props.contest.data.length; i++) {
                if (tmpPlace === null && this.props.contest.data[i].entityName === this.props.activeContestant) {
                    tmpPlace = i + 1;
                    break;
                }
            }
            numberJsx = (
                <div className="metrics-contest-item-number">{this.convertToPlacement(tmpPlace)}</div>
            );
        }

        return (
            <div className="metrics-contest-item-contest-number-container">
                {numberJsx}
                {numberIconJsx}
            </div>
        );
    }

    generateMainToggler() {

        let toggleStyle = {
            transform: this.props.expanded ? "rotateX(180deg)" : "rotateX(0deg)"
        }

        return (
            <div className="material-icons metrics-contest-item-toggle-icon" style={toggleStyle}>
                keyboard_arrow_down
            </div>
        );
    }

    generateRaffleMeat() {

        if (this.props.activeContestant === null || this.props.contest.longData[this.props.activeContestant] === undefined) {
            let result = [];

            let contestantIcon = "person";
            if (this.props.contest.identity.participantType === "loc") {
                contestantIcon = "store_mall_directory";
            }

            for (var i = 0; i < this.props.contest.rankedData.length; i++) {
                let dat = this.props.contest.rankedData[i];
                result.push((
                    <div className="placement-outer" style={{ borderBottom: i < this.props.contest.rankedData.length - 1 ? 'solid 1px rgba(0, 0, 0, 0.09)' : 'none' }}>
                        <div className="placement-icon-container">
                            <div className="material-icons placement-icon">{contestantIcon}</div>
                        </div>
                        <div className="placement-text-container">
                            <div className={"placement-text-top" + (dat.entitySubName === "" ? " centered" : "")}>{this.props.isBlurred && dat.entityName != this.props.myDataName ? "Jane Smith" : dat.entityName}</div>
                            {dat.entitySubName === "" ? null : (<div className="placement-text-bottom">{dat.entitySubName}</div>)}
                        </div>
                        <div className="placement-numbers-container">
                            <div className="placement-numbers-top">{this.convertToPlacement(i + 1)}</div>
                            <div className="placement-numbers-bottom">{this.numberToShorthand(dat.ticketCount) + " "}<span className="material-icons" style={{ fontSize: '1rem', height: '1.125rem', verticalAlign: 'middle' }}>local_activity</span></div>
                        </div>
                    </div>
                ))
            }

            return result;

        } else {

            let relevantLongData = this.props.contest.longData[this.props.activeContestant];
            let xData = relevantLongData.reduce((r, e) => { r.push(e.dateIndex); return r; }, [])
            let yData = relevantLongData.reduce((r, e) => { r.push(e.ticketCount); return r; }, [])

            return (
                <div className="metrics-contest-item-meat-inner">
                    <div className="metrics-contest-item-chart-container">
                        {this.chartHelper.generateBarChart(xData, yData)}
                    </div>
                    <div className="metrics-contest-item-bottom-message">
                        {}
                    </div>
                </div>
            )
        }



        return null;

        (
            <div className="metrics-contest-item-meat-inner">
                <div className="metrics-contest-item-chart-container">
                    {this.chartHelper.generateContestRaffleChart(identity, userStanceObj, parseInt(moment(new Date(this.props.selectedDate)).format("YYYYMMDD")))}
                </div>
                <div className="metrics-contest-item-bottom-message">
                    {identity.contestType + " | " + identity.timeFrame}
                </div>
            </div>
        );
    }

    generateRankedMeat() {
        let result = [];

        let contestantIcon = "person";
        if (this.props.contest.identity.participantType === "loc") {
            contestantIcon = "store_mall_directory";
        }

        let top5 = this.props.contest.data.slice(0, 5);
        let top5Names = top5.reduce((r, e) => { r.push(e.entityName); return r; }, []);
        let rankLimit = top5.length < 5 ? top5.length : 5;

        for (var i = 0; i < rankLimit; i++) {
            let dat = this.props.contest.data[i];
            result.push((
                <div className="placement-outer" style={{ borderBottom: i < rankLimit - 1 ? 'solid 1px rgba(0, 0, 0, 0.09)' : 'none' }}>
                    <div className="placement-icon-container">
                        <div className="material-icons placement-icon">{contestantIcon}</div>
                    </div>
                    <div className="placement-text-container">
                        <div className={"placement-text-top" + (dat.entitySubName === "" ? " centered" : "")}>{this.props.isBlurred && dat.entityName != this.props.myDataName ? "Jane Smith" : dat.entityName}</div>
                        {dat.entitySubName === "" ? null : (<div className="placement-text-bottom">{dat.entitySubName}</div>)}
                    </div>
                    <div className="placement-numbers-container">
                        <div className="placement-numbers-top">{this.convertToPlacement(i + 1)}</div>
                        <div className="placement-numbers-bottom">{dat.value}</div>
                    </div>
                </div>
            ))
        }

        if (!top5Names.includes(this.props.activeContestant)) {

            let tmpEmp = null;
            let tmpPlace = null;
            for (var i = 0; i < this.props.contest.data.length; i++) {
                if (tmpEmp === null && this.props.contest.data[i].entityName === this.props.activeContestant) {
                    tmpEmp = this.props.contest.data[i];
                    tmpPlace = i + 1;
                    break;
                }
            }

            if (tmpEmp != null) {
                result.push((
                    <div className="placement-outer" style={{ borderTop: 'solid 1px rgba(0, 126, 181, 1)' }}>
                        <div className="placement-icon-container">
                            <div className="material-icons placement-icon">{contestantIcon}</div>
                        </div>
                        <div className="placement-text-container">
                            <div className={"placement-text-top" + (tmpEmp.entitySubName === "" ? " centered" : "")}>{this.props.isBlurred && tmpEmp.entityName != this.props.myDataName ? "Jane Smith" : tmpEmp.entityName}</div>
                            {tmpEmp.entitySubName === "" ? null : (<div className="placement-text-bottom">{tmpEmp.entitySubName}</div>)}
                        </div>
                        <div className="placement-numbers-container">
                            <div className="placement-numbers-top" style={{ color: '#000000' }}>{this.convertToPlacement(tmpPlace)}</div>
                            <div className="placement-numbers-bottom">{tmpEmp.value}</div>
                        </div>
                    </div>
                ));
            }
        }

        return result;
    }

    render() {

        let outerStyle = {
            position: 'relative',
            height: '4.7rem',
            transition: 'height 0.25s ease-in-out 0s'
        }

        if (!this.props.expanded) {
            outerStyle.height = '4.7rem';
        } else if (this.props.contest.type === 'raffle') {
            if (this.props.activeContestant === null) {
                outerStyle.height = '19rem';
            } else {
                outerStyle.height = '16.85rem';
            }
        } else if (this.props.contest.type === 'ranked') {

            let topFive = this.props.contest.data.slice(0, 5).reduce((r, e) => { r.push(e.entityName); return r; }, [])

            if (this.props.activeContestant != null && !topFive.includes(this.props.activeContestant)) {
                outerStyle.height = '21.6rem';
            } else {
                outerStyle.height = '19rem';
            }
        }

        let mainIconJsx = this.generateMainIcon();
        let mainTitleJsx = this.generateMainTitle();
        let mainNumbersJsx = this.generateMainNumbers();
        let mainTogglerJsx = this.generateMainToggler();

        let meatJsx = null;
        if (this.props.contest.type === "raffle") {
            meatJsx = this.generateRaffleMeat();
        } else if (this.props.contest.type === "ranked") {
            meatJsx = this.generateRankedMeat();
        }

        return (
            <div className="metrics-central-regular-card-container" style={outerStyle} onClick={this.toggleExpanded}>
                <div className="metrics-contest-item-top-bar">
                    {mainIconJsx}
                    {mainTitleJsx}
                    {mainNumbersJsx}
                    {mainTogglerJsx}
                </div>
                <div className="metrics-contest-item-meat-container">
                    {meatJsx}
                </div>
            </div>
        );
    }
}